import { Reducer } from 'redux';
import {
    OnboardingSurveyState,
    OnboardingSurveyActionTypes,
    LoadOnboardingSurveySuccessAction,
    OnboardingSurveyLoadingState,
} from './types';

const defaultState: OnboardingSurveyState = {
    isSaving: false,
    isSaved: false,
    loaded: OnboardingSurveyLoadingState.Default,
};

const saveOnboardingSurveyStart = (state: OnboardingSurveyState): OnboardingSurveyState => ({
    ...state,
    isSaving: true,
    isSaved: false,
});

const saveOnboardingSurveySuccess = (state: OnboardingSurveyState): OnboardingSurveyState => ({
    ...state,
    isSaving: false,
    isSaved: true,
});

const saveOnboardingSurveyError = (state: OnboardingSurveyState): OnboardingSurveyState => ({
    ...state,
    isSaving: false,
    isSaved: false,
});

const loadOnboardingSurveyStart = (state: OnboardingSurveyState): OnboardingSurveyState => ({
    ...state,
    loaded: OnboardingSurveyLoadingState.Loading,
});

const loadOnboardingSurveyError = (state: OnboardingSurveyState): OnboardingSurveyState => ({
    ...state,
    loaded: OnboardingSurveyLoadingState.Error,
});

const loadOnboardingSurveySuccess = (
    state: OnboardingSurveyState,
    action: LoadOnboardingSurveySuccessAction
): OnboardingSurveyState => ({
    ...state,
    loaded: OnboardingSurveyLoadingState.Loaded,
    completedFormData: action.payload,
});

const reducer: Reducer<OnboardingSurveyState> = (
    state: OnboardingSurveyState = defaultState,
    action
): OnboardingSurveyState => {
    switch (action.type) {
        case OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_START:
            return saveOnboardingSurveyStart(state);
        case OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_SUCCESS:
            return saveOnboardingSurveySuccess(state);
        case OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_ERROR:
            return saveOnboardingSurveyError(state);

        case OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_START:
            return loadOnboardingSurveyStart(state);
        case OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_SUCCESS:
            return loadOnboardingSurveySuccess(state, action as LoadOnboardingSurveySuccessAction);
        case OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_ERROR:
            return loadOnboardingSurveyError(state);
        default:
            return state;
    }
};

export { reducer as onboardingSurvey };

export default reducer;
